<script lang="ts">
  export let title: string
</script>

<div class="flex flex-col gap-1">
  <span class="font-medium text-foreground">{title}</span>
  <span class="[&_a]:text-primary [&_a]:underline-offset-2 [&_a:hover]:underline"><slot /></span>
</div>
